function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 32,
  fill: "#27AE60"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 71.9999C22.3264 71.9999 8 57.6735 8 39.9999C8 22.3263 22.3264 7.99988 40 7.99988C57.6736 7.99988 72 22.3263 72 39.9999C72 57.6735 57.6736 71.9999 40 71.9999ZM36.8096 52.7999L59.4336 30.1727L54.9088 25.6479L36.8096 43.7503L27.7568 34.6975L23.232 39.2223L36.8096 52.7999Z",
  fill: "#E6FFDB"
});

function SvgSuccess({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iMzIiIGZpbGw9IiMyN0FFNjAiLz4KPHBhdGggZD0iTTQwIDcxLjk5OTlDMjIuMzI2NCA3MS45OTk5IDggNTcuNjczNSA4IDM5Ljk5OTlDOCAyMi4zMjYzIDIyLjMyNjQgNy45OTk4OCA0MCA3Ljk5OTg4QzU3LjY3MzYgNy45OTk4OCA3MiAyMi4zMjYzIDcyIDM5Ljk5OTlDNzIgNTcuNjczNSA1Ny42NzM2IDcxLjk5OTkgNDAgNzEuOTk5OVpNMzYuODA5NiA1Mi43OTk5TDU5LjQzMzYgMzAuMTcyN0w1NC45MDg4IDI1LjY0NzlMMzYuODA5NiA0My43NTAzTDI3Ljc1NjggMzQuNjk3NUwyMy4yMzIgMzkuMjIyM0wzNi44MDk2IDUyLjc5OTlaIiBmaWxsPSIjRTZGRkRCIi8+Cjwvc3ZnPgo=";
export { SvgSuccess as ReactComponent };